/* * 本页面为通关单新增和通关单修改界面 * 通过pageType字段来区分：1新增，2修改 *
*/
<template>
  <div class="page-view container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title>
        企业信息注册
        <template slot="breadcrumb">
          <e6-breadcrumb :breadcrumbs="breadcrumbs"></e6-breadcrumb>
        </template>
        <el-button type="text" @click="showViewer = true">注册指南</el-button>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- content -->
    <section class="content-section">
      <div class="form-wrapper">
        <e6-form-extend
          class="e6-from--column-2"
          ref="formExtend"
          :formExtend="formExtend"
          :inline="true"
          label-width="200px"
          :submitLoadingState="loadingState"
          @submitForm="handleSubmitForm"
          @resetForm="handleResetForm"
        >
          <template slot-scope="slotForms">
            <el-form-item
              label="企业名称"
              prop="forms.comparyName"
              :rules="[
                {
                  required: true,
                  message: '请输入企业名称',
                  trigger: 'blur'
                },
                { validator: CheckComparyNameLength, trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="slotForms.forms.comparyName"
                placeholder="企业名称"
                clearable
              ></el-input>
            </el-form-item>
            <!--<el-form-item-->
            <!--label="企业注册地址"-->
            <!--prop="forms.regisAddress"-->
            <!--:rules="[-->
            <!--{-->
            <!--required: true,-->
            <!--message: '请输入企业注册地址',-->
            <!--trigger: 'blur'-->
            <!--},-->
            <!--{ validator: CheckRemarkLength, trigger: 'blur' }-->
            <!--]"-->
            <!--&gt;-->
            <!--<el-input-->
            <!--v-model="slotForms.forms.regisAddress"-->
            <!--placeholder="企业注册地址"-->
            <!--clearable-->
            <!--&gt;</el-input>-->
            <!--</el-form-item>-->
            <!--<el-form-item-->
            <!--prop="forms.provinceId"-->
            <!--label="所属省"-->
            <!--:rules="[{ required: true, message: '所属省', trigger: 'change' }]"-->
            <!--&gt;-->
            <!--<el-select-->
            <!--v-model="slotForms.forms.provinceId"-->
            <!--placeholder="所属省"-->
            <!--@change="provinceChange"-->
            <!--clearable-->
            <!--filterable-->
            <!--&gt;-->
            <!--<el-option-->
            <!--v-for="item in provinceList"-->
            <!--:key="item.id"-->
            <!--:label="item.name"-->
            <!--:value="item.id"-->
            <!--&gt;</el-option>-->
            <!--</el-select>-->
            <!--</el-form-item>-->

            <!--<el-form-item-->
            <!--prop="forms.cityId"-->
            <!--label="所属市"-->
            <!--:rules="[{ required: true, message: '所属市', trigger: 'change' }]"-->
            <!--&gt;-->
            <!--<el-select-->
            <!--v-model="slotForms.forms.cityId"-->
            <!--placeholder="所属市"-->
            <!--@change="cityChange"-->
            <!--clearable-->
            <!--filterable-->
            <!--&gt;-->
            <!--<el-option-->
            <!--v-for="item in cityList"-->
            <!--:key="item.id"-->
            <!--:label="item.name"-->
            <!--:value="item.id"-->
            <!--&gt;</el-option>-->
            <!--</el-select>-->
            <!--</el-form-item>-->

            <!--<el-form-item-->
            <!--prop="forms.countyName"-->
            <!--label="所属区县"-->
            <!--:rules="[-->
            <!--{ required: true, message: '所属区县', trigger: 'change' }-->
            <!--]"-->
            <!--&gt;-->
            <!--<el-select-->
            <!--v-model="slotForms.forms.countyName"-->
            <!--placeholder="所属区县"-->
            <!--clearable-->
            <!--filterable-->
            <!--&gt;-->
            <!--<el-option-->
            <!--v-for="item in countyList"-->
            <!--:key="item.id"-->
            <!--:label="item.name"-->
            <!--:value="item.name"-->
            <!--&gt;</el-option>-->
            <!--</el-select>-->
            <!--</el-form-item>-->
            <div class="group_form">
              <el-form-item
                label="企业所属地"
                prop="forms.regisAreas"
                class="address"
              >
                <e6-city
                  ref="e6City"
                  :format="$GLOBAL_CONFIG.e6City.format"
                  :placeholder="$GLOBAL_CONFIG.e6City.placeholder"
                  :label="slotForms.forms.regisAreas"
                  class="e6-city"
                  @selected="citysSelect"
                ></e6-city>
                <!-- :fixed-bin="$GLOBAL_CONFIG.e6City.bin" -->
              </el-form-item>

              <!--<el-form-item-->
              <!--label="注册地址"-->
              <!--prop="forms.regisArea"-->
              <!--class="address"-->
              <!--&gt;-->
              <!--<e6-city-->
              <!--ref="e6City"-->
              <!--:format="$GLOBAL_CONFIG.e6City.format"-->
              <!--:placeholder="$GLOBAL_CONFIG.e6City.placeholder"-->
              <!--:label="slotForms.forms.regisArea"-->
              <!--class="e6-city"-->
              <!--@selected="citySelect"-->
              <!--:fixed-bin="$GLOBAL_CONFIG.e6City.bin"-->
              <!--&gt;</e6-city>-->
              <!--</el-form-item>-->
              <el-form-item prop="forms.regisAddress">
                <el-button
                  @click="selectAddress()"
                  :class="slotForms.forms.regisAddress ? '' : 'show_tips'"
                >
                  <span :title="regisAddress" class="register-txt">{{
                    slotForms.forms.regisAddress
                  }}</span>
                  <i class="e6-icon-map_line"></i>
                </el-button>
              </el-form-item>
            </div>

            <el-form-item
              label="角色属性"
              prop="forms.userAppTypeList"
              :rules="[
                {
                  type: 'array',
                  required: true,
                  message: '请至少选择一个角色属性',
                  trigger: 'change'
                }
              ]"
            >
              <el-checkbox-group
                v-model="slotForms.forms.userAppTypeList"
                @change="roleChange"
              >
                <el-checkbox :label="0">企业</el-checkbox>
                <el-checkbox :label="30">检测机构</el-checkbox>
                <el-checkbox :label="20">消毒机构</el-checkbox>
                <el-checkbox :label="40">政府部门 </el-checkbox>
                <el-checkbox :label="50">测试</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item
              label="社会统一信用代码"
              prop="forms.creditUnicode"
              :rules="[
                {
                  required: true,
                  message: '请输入社会统一信用代码',
                  trigger: 'blur'
                },
                { validator: CheckCreditUnicode, trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="slotForms.forms.creditUnicode"
                placeholder="社会统一信用代码"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="forms.corpCategoryList"
              label="企业类别"
              :rules="[
                {
                  required: true,
                  message: '请选择企业类别',
                  trigger: 'change'
                }
              ]"
            >
              <el-select
                ref="dictSelect"
                v-model="slotForms.forms.corpCategoryList"
                placeholder="企业类别"
                @change="dictSelectChange"
                size="mini"
                clearable
                filterable
                multiple
                collapse-tags="collapse-tags"
              >
                <el-option
                  v-for="item in dictOptions"
                  :disabled="item.disabled"
                  :key="item.dicId"
                  :label="item.dicName"
                  :value="item.dicId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              prop="forms.corpCategoryStr"
              label="其他企业类别"
              v-if="
                slotForms.forms.corpCategoryList.length &&
                  slotForms.forms.corpCategoryList[0] === 999
              "
              :rules="[
                {
                  required: true,
                  message: '请输入其他企业类别',
                  trigger: 'change'
                }
              ]"
            >
              <el-input
                placeholder="企业类别"
                v-model="slotForms.forms.corpCategoryStr"
                clearable
              >
              </el-input>
            </el-form-item>
            <el-form-item
              prop="forms.corpNature"
              label="企业性质"
              :rules="[
                {
                  required: true,
                  message: '请选择企业性质',
                  trigger: 'change'
                }
              ]"
            >
              <dict-select
                v-model="slotForms.forms.corpNature"
                placeholder="企业性质"
                :pkey="'corp_nature'"
              ></dict-select>
            </el-form-item>
            <el-form-item
              label="企业联系电话"
              prop="forms.comparyTel"
              :rules="[{ validator: CheckPhone, trigger: 'change' }]"
            >
              <el-input
                v-model="slotForms.forms.comparyTel"
                placeholder="企业联系电话"
                clearable
              ></el-input>
            </el-form-item>
            <!-- <el-form-item
              label="是否城配企业"
              prop="forms.isCpCorp"
              :rules="[
                {
                  required: true,
                  message: '请选择',
                  trigger: 'change',
                },
              ]"
            >
              <el-radio-group v-model="slotForms.forms.isCpCorp">
                <el-radio label="0">否</el-radio>
                <el-radio label="1">是</el-radio>
              </el-radio-group>
            </el-form-item> -->
            <!-- <el-form-item
              label="注册用户名"
              prop="forms.userName"
              :rules="[
                {
                  required: true,
                  message: '请输入注册用户名',
                  trigger: 'blur'
                },
                { validator: CheckComparyNameLength, trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="slotForms.forms.userName"
                placeholder="请使用企业全称"
                clearable
              ></el-input>
            </el-form-item> -->
            <el-form-item
              label="用户名"
              prop="forms.userCode"
              :rules="[
                {
                  required: true,
                  message: '请输入用户名',
                  trigger: 'blur'
                },
                { validator: CheckComparyNameLength, trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="slotForms.forms.userCode"
                placeholder="用户名"
                clearable
              ></el-input>
              <span class="item--recommon">登录平台/粤冷链账号</span>
            </el-form-item>
            <el-form-item
              label="密码"
              prop="forms.userPassWord"
              :rules="[
                {
                  required: true,
                  message: '请输入密码',
                  trigger: 'blur'
                },
                { validator: CheckVehicleIdentificationNo, trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="slotForms.forms.userPassWord"
                placeholder="8-16位数字字母组合"
                show-password
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              label="联系人姓名"
              prop="forms.comparyContacts"
              :rules="[
                {
                  required: true,
                  message: '请输入联系人姓名',
                  trigger: 'blur'
                },
                { validator: CheckComparyNameLength, trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="slotForms.forms.comparyContacts"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              label="联系人手机号"
              prop="forms.comparyContactsTel"
              :rules="[
                {
                  required: true,
                  message: '请输入联系人手机号',
                  trigger: 'blur'
                },
                { validator: CheckPhone, trigger: 'blur' }
              ]"
            >
              <el-input
                v-model="slotForms.forms.comparyContactsTel"
                clearable
              ></el-input>
            </el-form-item>
            <!-- <el-form-item
              label="固定电话"
              prop="forms.fixedTel"
              :rules="[{ validator: CheckPhone, trigger: 'change' }]"
            >
              <el-input v-model="slotForms.forms.fixedTel" clearable></el-input>
            </el-form-item> -->
            <el-form-item
              label="身份证号码"
              prop="forms.idCode"
              :rules="[
                {
                  required: true,
                  message: '请输入身份证号码',
                  trigger: 'blur'
                },
                { validator: validatorIdCard, trigger: 'blur' }
              ]"
            >
              <el-input v-model="slotForms.forms.idCode" clearable></el-input>
            </el-form-item>
            <el-form-item
              label="邮箱"
              prop="forms.mainBox"
              :rules="[{ validator: CheckEmail, trigger: 'blur' }]"
            >
              <el-input v-model="slotForms.forms.mainBox" clearable></el-input>
            </el-form-item>
            <el-form-item
              label="所任职位"
              prop="forms.job"
              :rules="[{ validator: CheckComparyNameLength, trigger: 'blur' }]"
            >
              <el-input v-model="slotForms.forms.job" clearable></el-input>
            </el-form-item>
            <el-form-item
              label="注册验证"
              prop="forms.smsNo"
              :rules="[
                {
                  required: true,
                  message: '请输入短信验证码',
                  trigger: 'blur'
                },
                { validator: validatorIntNum, trigger: 'blur' }
              ]"
              ><el-input
                class="smsWidth"
                v-model="slotForms.forms.smsNo"
                clearable
              ></el-input
              >&emsp;<el-button
                type="info"
                v-show="Verification"
                @click="handleClick"
              >
                获取验证码
              </el-button>
              <el-button type="info" v-show="!Verification" disabled>
                <span>{{ timer }}</span
                >秒后重新获取
              </el-button>
            </el-form-item>
            <div class="imgUpload">
              <!-- 企业logo -->
              <el-form-item
                prop="forms.logoImg"
                label="企业Logo"
                :rules="[
                  {
                    required: true,
                    message: '请选择企业Logo',
                    trigger: 'change'
                  }
                ]"
                ref="uploadElement"
              >
                <el-upload
                  class="el-upload-list__item-thumbnail"
                  :class="{ hide: hideUploadLogo }"
                  action="/app/file/upload"
                  :on-preview="handlePreview"
                  :on-remove="
                    (file, fileList) => handleRemove(file, fileList, 'logoImg')
                  "
                  :on-success="res => handleAvatarSuccess(res, 'logoImg')"
                  :on-change="
                    (file, fileList) => handleChange(file, fileList, 'logoImg')
                  "
                  :beforeUpload="beforeAvatarUpload"
                  :file-list="fileListLogo"
                  list-type="picture-card"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    只能上传jpg/png文件，且不超过2M
                  </div>
                </el-upload>
              </el-form-item>
              <!-- 营业执照 -->
              <el-form-item
                prop="forms.businessLicPhoto"
                label="营业执照"
                :rules="[
                  {
                    required: true,
                    message: '请选择营业执照',
                    trigger: 'change'
                  }
                ]"
                ref="uploadElement"
                class="img--back"
              >
                <el-upload
                  class="el-upload-list__item-thumbnail"
                  :class="{ hide: hideUploadLicence }"
                  action="/app/file/upload"
                  :on-preview="handlePreview"
                  :on-remove="
                    (file, fileList) =>
                      handleRemove(file, fileList, 'businessLicPhoto')
                  "
                  :on-success="
                    res => handleAvatarSuccess(res, 'businessLicPhoto')
                  "
                  :on-change="
                    (file, fileList) =>
                      handleChange(file, fileList, 'businessLicPhoto')
                  "
                  :beforeUpload="beforeAvatarUpload"
                  :file-list="fileListLicence"
                  list-type="picture-card"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    只能上传jpg/png文件，且不超过2M
                  </div>
                </el-upload>
              </el-form-item>
              <!-- 资质证明 -->
              <el-form-item
                prop="forms.comparyQualifi"
                label="资质证明"
                :rules="
                  cerImgCheck === true
                    ? [
                        {
                          required: true,
                          message: '请选择资质证明',
                          trigger: 'change'
                        }
                      ]
                    : []
                "
                ref="uploadElement"
                class="img--back"
              >
                <el-upload
                  class="el-upload-list__item-thumbnail"
                  :class="{ hide: hideUploadCer }"
                  action="/app/file/upload"
                  :on-preview="handlePreview"
                  :on-remove="
                    (file, fileList) =>
                      handleRemove(file, fileList, 'comparyQualifi ')
                  "
                  :on-success="
                    res => handleAvatarSuccess(res, 'comparyQualifi ')
                  "
                  :on-change="
                    (file, fileList) =>
                      handleChange(file, fileList, 'comparyQualifi ')
                  "
                  :beforeUpload="beforeAvatarUpload"
                  :file-list="fileListCer"
                  list-type="picture-card"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    只能上传jpg/png文件，且不超过2M
                  </div>
                </el-upload>
              </el-form-item>
              <el-dialog
                :visible.sync="dialogVisible"
                :modal-append-to-body="false"
              >
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </div>

            <div align="center">
              <span class="spanStyle">注册用户服务协议</span>
              <el-input
                type="textarea"
                disable="true"
                readonly
                :rows="10"
                placeholder="尊敬的用户，欢迎您注册成为广东省冷链公共服务管理平台的用户。在注册前请您仔细阅读如下服务条款： 本服务协议双方为本平台与本平台用户，本服务协议具有合同效力。 您确认本服务协议后，本服务协议即在您和本平台之间产生法律效力。请您务必在注册之前审慎阅读全部协议内容，并充分理解协议中相关条款内容，特别是以粗体下划线标识的条款，因为这些条款可能会明确您应履行的义务或对您的权利有所限制，您应重点阅读。如有任何疑问，可向本平台客服人员咨询。
    当您按照注册页面提示填写信息、阅读并同意协议且完成全部注册程序后，即表示您已充分阅读、理解并接受协议的全部内容。如您因平台服务与本平台发生争议的，适用本用户协议处理。如您在使用平台服务过程中与其他用户或第三方发生争议的，依您与其他用户或第三方达成的协议处理。
    阅读协议的过程中，如果您不同意相关协议或其中任何条款约定，您应立即停止注册程序。
    1．本平台服务条款的确认和接纳 本平台各项服务的所有权和运作权归本平台拥有。
    2．用户必须： (1)自行配备上网的所需设备， 包括个人电脑、调制解调器或其他必备上网装置。 (2)自行负担个人上网所支付的与此服务有关的电话费用、 网络费用。
    3．用户在本平台上不得发布下列违法信息： (1)反对宪法所确定的基本原则的； (2)危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的； (3)损害国家荣誉和利益的； (4)煽动民族仇恨、民族歧视，破坏民族团结的； (5)破坏国家宗教政策，宣扬邪教和封建迷信的； (6)散布谣言，扰乱社会秩序，破坏社会稳定的； (7)散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的； (8)侮辱或者诽谤他人，侵害他人合法权益的； (9)含有法律、行政法规禁止的其他内容的。
    4． 有关资料 用户同意： (1) 提供及时、详尽及准确的企业及个人资料。 (2)同意接收来自本平台的信息。 (3) 不断更新注册资料，符合及时、详尽准确的要求。所有原始键入的资料将引用为注册资料。 (4)本平台不公开用户的姓名、地址、电子邮箱和笔名，以下情况除外： （a）用户授权本平台透露这些信息。 （b）相应的法律及程序要求本平台提供用户的个人资料。
    如果用户提供的资料包含有不正确的信息，平台保留结束用户使用本平台信息服务资格的权利。平台对所有用户信息本着审慎原则，包括但不限于查看任何登记资料的真实性、完整性、适用性及是否为最新资料的责任，但是对于用户因平台信息造成的损失平台不承担任何责任。
    5. 服务条款的修改 本平台有权在必要时修改服务条款，本平台服务条款一旦发生变动，将会按照本协议相关条款进行通告。如果不同意所改动的内容，用户可以主动取消获得的本平台信息服务。如果用户继续享用本平台信息服务，则视为接受服务条款的变动。平台有权对平台功能进行升级和改造，有权基于服务的稳定对相关服务器进行停机维护，平台在行使以上权利时，将尽力不对用户的使用造成影响。若影响用户使用的，将会提前进行通告。
    6． 用户隐私制度 尊重用户隐私是本平台的基本原则。本平台不会在未经合法用户授权时公开、编辑或透露其注册资料及保存在本平台中的非公开内容，除非有法律许可要求或本平台在诚信的基础上认为透露这些信息在以下四种情况是必要的： (1) 遵守有关法律规定，遵从本平台合法服务程序。 (2) 保持维护本平台的商标所有权。 (3) 在紧急情况下竭力维护用户和社会大众的隐私安全。 (4)符合其他相关的要求。 本平台保留发布用户数据分析资讯的权利。
    7．用户的帐号、密码和安全性 您一旦注册成功成为用户，您将得到一个帐号和密码，每个用户都要对其帐户中的所有活动和事件负全责。您可随时根据指示改变您的密码，也可以结束旧的帐户重开一个新帐户。用户同意若发现任何非法使用用户帐号或安全漏洞的情况，请立即通告本平台。用户不应将其帐号、密码转让或出借予他人使用。如用户发现其帐号遭他人非法使用，应立即通知本平台。因黑客行为、病毒等原因或因用户的保管疏忽导致帐号、密码遭他人非法使用造成损失的，本平台不承担任何责任。
    8． 拒绝提供担保 用户明确同意信息服务的使用由用户承担风险。 本平台不担保服务不会受中断，对服务的及时性、安全性、出错发生都不作担保，但会在能力范围内，避免出错。
    9．有限责任 本平台对任何直接、间接、偶然、特殊及继起的损害不负责任，这些损害来自包括但不限于：不正当使用本平台服务，或用户传送的信息不符合规定等。但平台会在能力范围内尽量避免这种损害的发生。
    10．信息的储存及限制 本平台有判定用户的行为是否符合本平台服务条款的要求和精神的权利，如果用户违背本平台服务条款的规定，本平台有权中断其服务的帐号。
    11．用户管理 用户必须遵循： (1) 使用信息服务不作非法用途。 (2) 不干扰或混乱网络服务。 (3) 遵守所有使用服务的网络协议、规定、程序和惯例。用户的行为准则是以因特网法规，政策、程序和惯例为根据的。
    12．结束服务用户若反对任何服务条款的建议或对后来的条款修改有异议，或对本平台服务不满，用户可以行使如下权利： (1) 不再使用本平台信息服务。 (2) 通知本平台停止对该用户的服务。 结束用户服务后，用户使用本平台服务的权利马上中止。从那时起，用户没有权利，本平台也没有义务传送任何未处理的信息或未完成的服务给用户或第三方。
    13．通告 所有发给用户的通告都可通过重要页面的公告或电子邮件或常规的信件传送。服务条款的修改、服务变更，或其它重要事件的通告都会以此形式进行。
    14．信息内容的所有权 本平台定义的信息内容包括：文字、软件、声音、相片、录像、图表，在广告中全部内容，本平台为用户提供的其它信息。所有这些内容均是本平台或其内容提供者的财产，受中国和国际版权法的保护。本平台上所有内容的汇编是本平台的排他财产，受中国和国际版权法的保护。本平台上所有软件都是平台或其软件供应商的财产，受中国和国际版权法的保护。所以，用户只能在本平台和相应授权下才能使用这些内容，而不能擅自复制、再造这些内容、或创造与内容有关的派生产品。
    15．法律 本协议的订立、执行和解释及争议的解决均应适用中国法律。用户和本平台一致同意服从本协议签订地有管辖权的法院管辖。如发生本平台服务条款与中华人民共和国法律相抵触时，则这些条款将完全按法律规定重新解释，而其它条款则依旧保持对用户的约束力。"
              ></el-input>
              <el-checkbox v-model="slotForms.forms.radio"
                >已阅读并已同意以上条款</el-checkbox
              >
            </div>
          </template>
          <template slot="submit">保存</template>
          <template slot="reset">返回</template>
        </e6-form-extend>
      </div>
    </section>
    <!-- content end -->
    <!-- 地图控件 -->
    <small-map
      ref="mapWin"
      title="地图标注"
      :optionMap="optionMap"
      :city="city"
      @showMapInfo="getMapInfo"
    ></small-map>

    <e6-image-viewer
      v-show="showViewer"
      :on-close="closeViewer"
      :url-list="[
        'https://cc.gdccpsmp.cn/app/file/download?fileName=RegistrationGuide.png'
      ]"
    >
    </e6-image-viewer>
  </div>
</template>
<script>
import e6City from "e6city";
import smallMap from "@/components/smallMap/smallMap";
import {
  RegisteredCompary,
  SendSMS,
  VerifyCode,
  CheckComparyNameAndCode
} from "@/api/base/compary";
import {
  CheckRemarkLength,
  CheckPhone,
  CheckEmail,
  validatorIdCard,
  CheckVehicleIdentificationNo,
  validatorIntNum,
  CheckComparyNameLength,
  CheckCreditUnicode
} from "@/utils/validation";
import { DeleteFile, FetchGetArea } from "@/api/public";
export default {
  components: { e6City, smallMap },
  data() {
    // 选择地图详情
    // const addressRule = (rule, value, callback) => {
    //   if (!this.formExtend.forms.regisAddress.length) {
    //     callback("请点击地图选择详情地址");
    //   } else {
    //     callback();
    //   }
    // };
    return {
      // 地图跳转传参
      optionMap: {
        lng: "",
        lat: "",
        city: "", //选择的城市名
        level: "", //省、市、区
        location: ""
      },
      city: "", //选择的市区
      breadcrumbs: [
        {
          path: "/login",
          isRedirect: true,
          meta: {
            title: "返回"
          }
        }
      ],
      dictOptions: [],
      formExtend: {
        forms: {
          smsNo: "",
          radio: "",
          comparyName: "",
          regisAddress: "", //注册详细地址
          provinceName: $GLOBAL_CONFIG.e6City.provinceName,
          provinceId: "",
          cityName: $GLOBAL_CONFIG.e6City.cityName,
          cityId: "",
          countyName: "",
          countyId: "",
          creditUnicode: "",
          comparyType: "",
          corpNature: "",
          comparyTel: "",
          isCpCorp: "",
          userName: "",
          userCode: "",
          userPassWord: "",
          comparyContacts: "",
          comparyContactsTel: "",
          fixedTel: "",
          idCode: "",
          mainBox: "",
          job: "",
          logoImg: "",
          corpCategoryStr: "",
          businessLicPhoto: "", //营业执照
          comparyQualifi: "", //资质证明

          regisArea: "", //注册地址省市区
          regisAreas: "",
          lon: "", //经度
          lat: "", //纬度
          corpCategoryList: "",
          // provinceOfName: '',
          // cityOfName:'',
          // countyOfName:''
          userAppTypeList: [] //角色属性
        },
        extends: []
      },
      hideUploadLogo: false,
      hideUploadLicence: false,
      hideUploadCer: false,
      dialogImageUrl: "",
      dialogVisible: false,
      fileListLogo: [], //logo
      fileListLicence: [], //营业执照
      fileListCer: [], //资质证明
      provinceList: [],
      cityList: [],
      countyList: [],
      dicTypeKeyList: [],
      comparyNameMessage: "",
      labelUuidMessage: "",
      comparyNameAlarmFlag: false,
      labelUuidAlarmFlag: false,
      sendTime: "", //记录发送短信事件
      Verification: true, //通过v-show控制显示获取还是倒计时
      timer: "", //定义初始时间为60s
      editState: false,
      CheckRemarkLength: CheckRemarkLength,
      validatorIdCard: validatorIdCard,
      CheckPhone: CheckPhone,
      CheckEmail: CheckEmail,
      CheckVehicleIdentificationNo: CheckVehicleIdentificationNo,
      validatorIntNum: validatorIntNum,
      CheckComparyNameLength: CheckComparyNameLength,
      CheckCreditUnicode: CheckCreditUnicode,
      loadingState: false,
      regisAddress: "",

      cerImgCheck: false, //控制资质证明是否校验
      cerImgKey: new Date().getTime(),

      showViewer: false
    };
  },
  created() {
    this.FetchGetArea(0, 1, 1);
    this.initDictSelect();
    let breadcrumb = {
      path: "/systemSettingDataDictionaryMaintenanceEdit",
      isRedirect: false,
      meta: {
        title: "企业信息注册"
      }
    };
    this.breadcrumbs.push(breadcrumb);
  },
  methods: {
    closeViewer() {
      this.showViewer = false;
    },
    citySelect(res) {
      if (res.province.name == "澳门") {
        this.cityName("澳门");
        this.optionMap.level = "city";
      } else if (res.province.name == "香港") {
        this.cityName("香港");
        this.optionMap.level = "city";
      } else if (res.province.name == "台湾省") {
        this.cityName("台湾省");
        this.optionMap.level = "city";
      } else {
        this.formExtend.forms.regisArea =
          res.province.name + res.city.name + res.district.name;
        this.city = res.city.name;
        this.optionMap.city = res.city.name;
        if (res.district.name === "") {
          if (res.city.name === "") {
            this.optionMap.level = "province";
          } else {
            this.optionMap.level = "city";
          }
        } else {
          this.optionMap.level = "district";
        }
      }
    },
    citysSelect(res) {
      if (res.province.name == "澳门") {
        this.cityName("澳门");
        this.optionMap.level = "city";
      } else if (res.province.name == "香港") {
        this.cityName("香港");
        this.optionMap.level = "city";
      } else if (res.province.name == "台湾省") {
        this.cityName("台湾省");
        this.optionMap.level = "city";
      } else {
        this.formExtend.forms.regisAreas =
          res.province.name + res.city.name + res.district.name;
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.city.name;
        this.formExtend.forms.countyName = res.district.name;
        this.city = res.city.name;
        this.optionMap.city = res.city.name;
        if (res.district.name === "") {
          if (res.city.name === "") {
            this.optionMap.level = "province";
          } else {
            this.optionMap.level = "city";
          }
        } else {
          this.optionMap.level = "district";
        }
      }
    },
    dictSelectChange(data) {
      const flag = data.some(id => id !== 999);
      const selected = data.some(id => id === 999);
      if (data.length && flag) {
        console.log(this.dictOptions);
        for (let i = 0; i < this.dictOptions.length; i++) {
          const datai = this.dictOptions[i];
          if (datai.dicId === 999) {
            this.dictOptions[i].disabled = true;
          }
        }
      } else if (selected) {
        for (let i = 0; i < this.dictOptions.length; i++) {
          const datai = this.dictOptions[i];
          if (datai.dicId !== 999) {
            this.dictOptions[i].disabled = true;
          }
        }
      } else {
        for (let i = 0; i < this.dictOptions.length; i++) {
          this.dictOptions[i].disabled = false;
        }
      }
    },
    /**
     *  初始化字典列表
     */
    initDictSelect() {
      console.log(1111111);
      this.$axios
        .post(
          "/base/dictionary/getDictByDicTypeKey",
          this.$qs.stringify({ dicTypeKey: "corp_category" })
        )
        .then(e => {
          console.log(1);
          if (e.data.code === 1) {
            e.data.result.forEach(item => {
              item.disabled = false;
            });
            console.log(e.data.result);
            this.dictOptions = e.data.result;
            console.log(this.dictOptions);
          } else {
            this.errorMessage(e.data.message, e.data.code);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    selectAddress() {
      if (!this.formExtend.forms.regisAreas.length) {
        this.$message.warning("请先选择省/市/区县");
        return;
      }
      this.optionMap.location = this.formExtend.forms.regisAddress;
      this.$refs.mapWin.showMap();
      // this.$refs.mapWin.loadQuery();
    },
    cityName(name) {
      this.formExtend.forms.regisArea = name;
      this.city = name;
      this.optionMap.city = name;
    },
    /**
     * 校验企业名称唯一性
     */
    checkComparyName() {
      if (
        this.formExtend.forms.comparyName &&
        this.formExtend.forms.comparyName.indexOf(" ") == -1
      ) {
        CheckComparyNameAndCode({
          comparyName: this.formExtend.forms.comparyName
        }).then(response => {
          if (response.code == 0) {
            if (response.message) {
              this.comparyNameAlarmFlag = true;
              console.log(this.comparyNameAlarmFlag);
              this.comparyNameMessage = response.message;
              this.$message({
                message: response.message,
                type: "warning"
              });
            } else {
              this.comparyNameAlarmFlag = false;
              this.comparyNameMessage = response.message;
            }
          }
          return this.comparyNameMessage;
        });
      }
    },
    //校验唯一码唯一性
    checkLabelUuid() {
      if (
        this.formExtend.forms.creditUnicode &&
        this.formExtend.forms.creditUnicode.indexOf(" ") == -1
      ) {
        CheckComparyNameAndCode({
          creditUnicode: this.formExtend.forms.creditUnicode
        }).then(response => {
          if (response.code == 0) {
            if (response.message) {
              this.labelUuidAlarmFlag = true;
              console.log(this.labelUuidAlarmFlag);
              this.labelUuidMessage = response.message;
              this.$message({
                message: response.message,
                type: "warning"
              });
            } else {
              this.labelUuidAlarmFlag = false;
              this.labelUuidMessage = response.message;
            }
          }
          return this.labelUuidMessage;
        });
      }
    },
    handleClick() {
      if (this.formExtend.forms.comparyContactsTel == "") {
        this.$message("请输入联系人手机号!");
        return;
      }
      this.SendSMS({ phone: this.formExtend.forms.comparyContactsTel });
      this.sendTime = new Date();
      this.Verification = false; //点击button改变v-show的状态
      this.timer = 300;
      let auth_timer = setInterval(() => {
        //定时器设置每秒递减
        this.timer--; //递减时间
        if (this.timer <= 0) {
          this.Verification = true; //60s时间结束还原v-show状态并清除定时器
          clearInterval(auth_timer);
        }
      }, 1000);
    },
    // 根据父级获取地区下拉框
    FetchGetArea(parentId, type, num) {
      FetchGetArea(parentId, type)
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            if (num == 1) {
              this.provinceList = response.result;
            } else if (num == 2) {
              this.cityList = response.result;
            } else if (num == 3) {
              this.countyList = response.result;
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 发送短信
    SendSMS(phone) {
      SendSMS(phone)
        .then(response => {
          response.result;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 校验验证码
    VerifyCode(phone, code) {
      VerifyCode(phone, code)
        .then(response => {
          if (response.code == 1) {
            if (this.timer <= 0) {
              this.$message.error("验证码已过期!");
              return;
            }
            if (this.formExtend.forms.radio == "") {
              this.$message.error("请同意服务协议");
              return;
            }
            this.loadingState = true;
            this.RegisteredCompary(Object.assign({}, this.formExtend.forms));
          } else {
            this.$message.error("验证码错误!");
            return;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //省选择事件
    provinceChange() {
      this.cityList = [];
      this.countyList = [];
      this.formExtend.forms.cityId = "";
      this.formExtend.forms.cityName = "";
      this.formExtend.forms.countyName = "";
      this.provinceList.forEach(item => {
        if (this.formExtend.forms.provinceId == item.id) {
          this.formExtend.forms.provinceName = item.name;
          return;
        }
      });
      this.FetchGetArea(this.formExtend.forms.provinceId, 2, 2);
    },
    //市选择事件
    cityChange() {
      this.coutyList = [];
      this.formExtend.forms.countyName = "";
      this.cityList.forEach(item => {
        if (this.formExtend.forms.cityId == item.id) {
          this.formExtend.forms.cityName = item.name;
          return;
        }
      });
      this.FetchGetArea(this.formExtend.forms.cityId, 3, 3);
    },
    //删除文件
    handleRemove(file, fileList, type) {
      if (type === "logoImg") {
        DeleteFile({ fileName: this.formExtend.forms.attachment });
        this.formExtend.forms.logoImg = "";
        this.hideUploadLogo = fileList.length >= 1;
      } else if (type === "businessLicPhoto") {
        DeleteFile({ fileName: this.formExtend.forms.attachment });
        this.formExtend.forms.businessLicPhoto = "";
        this.hideUploadLicence = fileList.length >= 1;
      } else if (type === "comparyQualifi ") {
        this.formExtend.forms.comparyQualifi = "";
        this.hideUploadCer = fileList.length >= 1;
      }
    },
    //点击附件
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //上传附件成功
    handleAvatarSuccess(res, type) {
      if (type === "logoImg") {
        this.formExtend.forms.logoImg = res.result.filename;
        this.$refs["uploadElement"].clearValidate();
      } else if (type === "businessLicPhoto") {
        this.formExtend.forms.businessLicPhoto = res.result.filename;
        this.$refs["uploadElement"].clearValidate();
      } else if (type === "comparyQualifi ") {
        this.formExtend.forms.comparyQualifi = res.result.filename;
        this.$refs["uploadElement"].clearValidate();
      }
    },
    //改变文件
    handleChange(file, fileList, type) {
      if (type === "logoImg") {
        this.hideUploadLogo = fileList.length >= 1;
      } else if (type === "businessLicPhoto") {
        this.hideUploadLicence = fileList.length >= 1;
      } else if (type === "comparyQualifi ") {
        this.hideUploadCer = fileList.length >= 1;
      }
    },
    beforeAvatarUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "jpg";
      const extension2 = testmsg === "png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!extension && !extension2) {
        this.$message({
          message: "上传文件只能是 jpg、png格式!",
          type: "warning"
        });
        return false;
      }
      if (!isLt2M) {
        this.$message({
          message: "上传文件大小不能超过 2MB!",
          type: "warning"
        });
        return false;
      }
      return (extension && isLt2M) || (extension2 && isLt2M);
    },
    // 新增，修改通关单数据
    RegisteredCompary(response) {
      RegisteredCompary(response)
        .then(response => {
          this.submitCallback(response);
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 新增通关单信息完成时的回调函数
    submitCallback(response) {
      let type = response.code === 1 ? "success" : "error";
      let message = response.message;
      this.$message({
        showClose: true,
        message: message,
        type: type,
        duration: 2000,
        onClose: () => {
          if (type === "success") {
            this.$router.push({
              path: "/baseCustomsDeclarationList",
              query: { refreshportion: true }
            });
          } else {
            this.loadingState = false;
          }
        }
      });
    },
    // 提交
    async handleSubmitForm(e) {
      if (e) {
        this.VerifyCode({
          mobile: this.formExtend.forms.comparyContactsTel,
          code: this.formExtend.forms.smsNo
        });
      }
    },
    // 取消
    handleResetForm() {
      this.$router.push("/login");
    },
    // 地图标注回调
    getMapInfo(data) {
      this.formExtend.forms.regisAddress = data.location;
      this.formExtend.forms.lon = data.lng;
      this.formExtend.forms.lat = data.lat;
      this.regisAddress = data.location;
    },
    //角色属性变化时的回调,主要用来控制选择某项时，激活或关闭资质证明必填校验
    roleChange(val) {
      if (val.indexOf(20) !== -1 || val.indexOf(30) !== -1) {
        this.cerImgCheck = true;
      } else {
        this.cerImgCheck = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.smsWidth {
  width: 198px !important;
}
.alarmColor {
  margin-bottom: -21px;
  margin-top: -5px;
  font-size: 12px;
  color: #f56c6c;
}
.spanStyle {
  margin: 0 0 15px 0;
}
.upload-demo {
  width: 300px;
  margin: 10 150px 10px 200px;
}
.page-view {
  height: 100%;
}
.title-section {
  padding: 15px 20px 10px;
}
.content-section {
  overflow: auto;
}
.content-section {
  .form-wrapper {
    padding-top: 20px;
    margin: 0 20px;
    background-color: #fff;

    .group_form {
      width: 50%;
      display: inline-block;
      vertical-align: top;
      .el-form-item {
        width: auto;
        .e6-city {
          width: 178px;
          /deep/ .city-input {
            width: 100% !important;
          }
        }
        &:last-child {
          width: calc(100% - 398px);
          max-width: 300px;
          /deep/.el-form-item__content {
            width: 100%;
            .el-button {
              width: 100%;
              &.show_tips::before {
                content: "在地图上标注";
                color: #898c91;
                position: absolute;
              }
              span {
                display: inline-block;
                width: calc(100% - 20px);
                overflow: hidden;
                text-overflow: ellipsis;
                margin-right: 5px;
              }
            }
          }
        }
      }
    }
  }
}
/deep/.hide .el-upload--picture-card {
  display: none;
}
/deep/.el-input--mini {
  font-size: 14px;
  color: #fff;
}
/deep/ .e6-from--column-2 {
  .el-input {
    width: 300px;
  }
  .el-textarea__inner {
    width: 1200px;
  }
}
.el-form {
  .item--recommon {
    margin-left: 5px;
    display: inline-block;
    color: #898c91;
    // position: absolute;
  }
  .imgUpload {
    width: auto;
    .el-form-item--mini {
      width: auto;
    }
  }
  .img--back {
    /deep/ .el-form-item__label {
      width: 100px !important;
    }
  }
}
</style>
